export default {
  statistics: {
    servicetype: "服务类型",
    search: "查询",
    exportfile: "导出",
    submit: "提交",
    createdate: "创建日期",
    orderno: "订单号",
    businestype: "业务类型",
    payment: "应付(含保险、服务费)",
    insufee: "保险费",
    servicefee: "服务费",
    productname: "产品名称",
    total: "合计",
    departmentname: "部门名称",
    selectdepart: "请选择部门",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    selectcostcenter: "请选择成本中心",
    selectExpenseDepartment: "请选择费用负担部门",
    projectcode: "项目代码",
    startdate: "开始日期",
    enddate: "截止日期",
    paytotalmoney: "消费总额",
    avgticketprice: "平均票价",
    avgroomfee: "平均房费",
    avgdiscount: "平均折扣",
    breakbtrip: "违背政策",
    advdayinfo: "提前预订天数情况",
    day: "天",
    departpaysort: "各部门消费排名",
    costpaysort: "各成本中心排名",
    expenseDepartmentRanking: "各费用负担部门排名",
    projectcodepaysort: "各项目代码排名",
    arrpaysort: "各目的地排名",
    tonglist: "统计列表",
    tongview: "统计视图",
  },
  order: {
    //15901610043
    ordertip: "您可以在线查看近一年的订单。如果需询看更久之前的订单，请致电：400-088-8020（免长话费）。",
    allorder: "所有订单",
    startdate: "开始日期",
    endadte: "结束日期",
    orderstatus: "订单状态",
    ordertype: "订单类型",
    searchkey: "输入商品名称或订单号进行搜索",
    search: "查询",
    number: "数量",
    orderdetail: "订单详情",
    ordertotalmoney: "订单总额",
    dealoperation: "交易操作",
    submit: "立即提交",
    approval: "立即审批",
    payment: "立即支付",
    createorder: "再次下单",
    oldsystem: "老系统",
    rejectReason: "审批备注",
    reapproval: "审批拒绝",
    approvalsucc: "审批通过",
    selectvoy: "请选择您需要退票的航程！",
    selectpass: "请选择您需要退票的旅客！",
    selectreason: "请选择您需要退票的理由！",
    amendsucc: "退票申请提交成功",
    flightchange: "机票改签",
    selectchangepass: "需要改签的旅客",
    oldvoyageinfo: "原航班信息",
    selectedflight: "已选航班",
    policyok: "符合规则",
    policyno: "违背规则",
    build: "机建",
    fuel: "燃油",
    changeflight: "修改航班",
    flightlist: "航班列表",
    changefee: "改签费用",
    changefeetip: "以下费用仅供参考，如有疑问请拨打客服电话",
    changefeeabout: "预计改签费(改签预订)",
    upcabinfeeabout: "预计升舱费",
    changeservicefee: "改签服务费",
    totalfee: "合计",
    changereason: "改签原因",
    changedetreason: "请输入改签详细原因(可不填)",
    back: "<<返回",
    submitapply: "提交申请",
    selectchangepass: "请选择旅客！",
    flightsearchfail: "未查询到符合条件的航班信息！",
    flightchangereason: "请选择改签原因",
    losesource: "Please check flights",
    flightchangesucc: "改签申请提交成功！",
    orderdetail: "订单信息",
    voyageinfo: "行程信息",
    flightpass: "出游人",
    contactpeople: "联系人",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    policynoreason: "违背政策原因",
    demandremark: "需求备注",
    fujianxinxi: "附件信息",
    btripinfo: "商旅信息",
    procode: "项目代码",
    btripaim: "差旅目的",
    btripMatter: "出差事由",
    approvalstatus: "审批状态",
    violate: "违背了",
    policydetail: "的政策",
    vioreason: "违背原因",
    reasondetail: "详细原因",
    order: "订单",
    bookingdate: "预订日期",
    orderid: "订单编号",
    oldorderid: "原始订单号",
    bookingway: "预订方式",
    paymentway: "支付方式",
    totalmoney: "总金额",
    submitorder: "提交订单",
    cancelorder: "取消订单",
    ordervoyage: "行程",
    realtake: "实际乘坐",
    share: "共享",
    orderchange: "我要改签",
    orderamend: "我要退票",
    departcity: "出发城市",
    arrivecity: "到达城市",
    departdate: "出发时间",
    arrivedate: "到达时间",
    hotelname: "酒店名称",
    hotelphone: "酒店电话",
    hoteladdress: "酒店地址",
    roomtype: "房间类型",
    cityname: "城市名称",
    arrivedate: "入住日期",
    departdate: "离店日期",
    startstation: "始发车站",
    endstation: "到达车站",
    seattype: "座位类型",
    tourpeople: "出游人",
    sequence: "序号",
    name: "姓名",
    cardno: "证件号码",
    birthday: "出生日期",
    phoneno: "手机号码",
    invoiceinfo: "凭证信息",
    invoiceid: "凭证编码",
    passname: "旅客名称",
    invoiceno: "凭证号",
    seatno: "座位号",
    tradeinfo: "交易信息",
    tradepeople: "交易人",
    tradeway: "交易方式",
    tradetype: "交易类型",
    trademoney: "交易金额",
    createtime: "创建时间",
    email: "邮箱",
    phone: "手机",
    applyamend: "退票申请",
    selectordervoyage: "选择行程",
    selectorderpass: "选择旅客",
    selectorderreason: "选择原因",
    cancel: "取 消",
    changeapply: "改签申请",
    adultticket: "成人票",
    amendfee: "退票费",
    samechangefee: "同舱改期费",
    changecondition: "签转条件",
    changeadopt: "允许转签",
    people: "人",
    completechange: "已变更完成",
    reimburseinfo: "报销信息",
    travleorderinfo: "可提供全额行程单",
    bagkg: "行李额",
    forfeebagkg: "免费托运行李额20KG",
    loading: "加载中......",
    endststion: "到达车站",
    waitapprove: "待审批",
    changeamendrule: "退改规则",
    trainamendrule:
      "对开车前8天(不含)以上退票的，不收取退票费。票面乘车站开车前48小时以上的，退票时收取票价5%的退票费;开车前24小时以上、不足48小时的，退票时收取票价10%的退票费;开车前不足24小时的，退票时收取票价20%退票费。",
    touramendrule: "已签订合同为准",
    selectPassengersChange: "请选择需要改签的旅客",
    fillFlight: "填写航班信息",
    depart: "出发",
    arrive: "到达",
    date: "日期",
    changereason: "请输入改签原因",
    dueTo: "预订于",
    for: "为",
    ChangeTo: "改签于",
    WasteBack: "退废于",
    ExpectedRefundFee: "预计退票费",
    reasonRejection: "请输入拒绝原因",
    ordeCancel: "订单取消",
    isCancel: "是否确认取消订单",
    confirm: "确 定",
    BusinessType: "业务类型",
  },
  system: {
    clear: "清除",
    combtripmemberlogin: "企业商旅会员登录",
    lchbtrip: "力程商旅",
    simple: "越简单",
    free: "越自由",
    lowermoney: "越省钱",
    prebtrip: "完美的差旅服务",
    unyouneed: "理解您的需求",
    servicenotime: "服务全面无时差",
    costcenlower: "差旅成本直降30%",
    peoplecenter: "个人中心",
    ri: "日",
    trtavleregtips: "金额为0表示不限制金额,机票舱位火车座位勾选为可用",
    firstcity: "一级城市",
    seccity: "二级城市",
    thrcity: "三级城市",
    none: "无",
    allmoney: "全价",
    discountdown: "折以下",
    deletefiletips: "确认执行删除操作？",
    tips: "提示",
    cancel: "取消",
    usericon: "头像",
    uploadusericon: "头像上传",
    changusericon: "头像更换",
    bangemail: "绑定邮箱",
    bangphone: "绑定手机号",
    orderid: "订单编号",
    ordervoyageinfo: "行程信息",
    bookingdate: "预订日期",
    orderstatus: "订单状态",
    bookinguser: "预订人",
    btriprule: "差旅规则",
    btripaim: "差旅目的",
    policyreason: "政策原因",
    bookinginfo: "预订须知",
    btripflow: "差旅审批",
    search: "查询",
    add: "添加",
    name: "名称",
    number: "编号",
    servicetype: "服务类型",
    chinese: "中文",
    english: "英文",
    operation: "操作",
    copy: "复制",
    update: "修改",
    delete: "删除",
    delsucc: "删除成功",
    inputcontent: "请输入内容",
    selectcustomers: "选择客户",
    zhdescribe: "中文描述",
    rule: "规则",
    ruleid: "规则编号",
    rulename: "规则名称",
    travelregulations: "差旅管控规则",
    endescribe: "英文描述",
    btripflowname: "差旅审批名称",
    btripflowrule: "差旅审批规则",
    selectbtriprule: "选择差旅规则",
    selectbtripflow: "选择审批流程",
    needflow: "差旅审批配置",
    roleapplybtrip: "规则适用角色",
    departrole: "部门角色",
    jobrole: "职位角色",
    employeeandcustomer: "员工常客",
    btripflowid: "差旅审批编号",
    btriprulename: "差旅规则名称",
    approvalfloename: "审批流程名称",
    flowid: "流程编号",
    back: "<< 返回",
    save: "保存",
    savesucc: "保存成功",
    operlogs: "操作日志",
    addsucc: "添加成功",
    updatesucc: "修改成功",
    businessname: "企业名称",
    businessmanage: "企业管理",
    servicemanage: "服务管理",
    reportsmanage: "报表管理",
    pleaseselect: "请选择",
    pleasewrite: "请填写",
    companyinfo: "公司信息",
    companyname: "公司名称",
    city: "城市",
    profession: "行业",
    contactname: "联系人姓名",
    selectcycle: "请选择周期",
    selectdate: "请选择日期",
    selecttrade: "请选择交易",
    phonenoerror: "手机格式错误",
    emailerror: "邮编格式错误",
    contactnameerror: "收件人名称不能为空",
    deliverymanage: "配送管理",
    addcontact: "新增地址",
    contactpeople: "收货人",
    address: "详细地址",
    remark: "备注",
    postcode: "邮政编码",
    contactphone: "联系手机",
    contactnickname: "地址简称",
    contactemail: "联系邮箱",
    defaultaddress: "默认地址",
    setdefaultaddress: "设为默认",
    addressinfo: "地址信息",
    peoplemanage: "个人管理",
    lasterorder: "近期订单",
    voyagesdate: "行程日历",
    voyagesremark: "行程备注",
    welcomelogin: "欢迎登陆",
    login: "登录",
    registernow: "企业注册",
    register: "注册",
    loginbyaccount: "账号密码登录",
    loginbyphone: "手机动态码登录",
    loginbyother: "您还可以使用以下方式登录",
    wechat: "微信",
    pleaseinputvalcode: "请输入验证码",
    loginredittips: "秒后将跳转到主页......",
    accountinfo: "账户信息",
    peopleregister: "个人用户",
    companyregister: "企业客户注册",
    kefucenter: "客服中心",
    loginout: "退出",
    account: "账号",
    pwd: "密码",
    pwdtips: "请输入密码",
    forgetpassword: "忘记密码?",
    saveloginstats: "记住登录状态",
    accounttips: "请输入手机号码或邮箱",
    password: "登录密码",
    passwordtips: "请输入8~16位",
    passwordfirstlevel: "弱",
    passwordfirstleveltips: "包含英文字母和数字",
    passwordsecleveltips: "包含英文字母、数字和特殊符号",
    passwordseclevel: "中",
    passwordlastleveltips: "包含大小写英文字母、数字和特殊符号",
    passwordlastlevel: "强",
    confirmpassword: "确认密码",
    validecode: "验证码",
    validecodeignorecase: "不区分大小写",
    changevalidecode: "换一张",
    dynavalidecode: "动态验证码",
    dynavalidecodetips: "请输入动态验证码",
    loginedregistertips: "你已登录力程商旅账户，若要注册个人账户请先退出!",
    agreeprotocol: "同意《服务协议》",
    reset: "重置",
    registeproblem: "注册遇到问题？",
    inputpwdagain: "请再次输入密码",
    notsamepwd: "两次输入密码不一致!",
    emailaccounttips: "发送邮箱验证码",
    phoneaccounttips: "发送手机验证码",
    sendvalidecode: "发送验证码",
    registersucc: "注册成功",
    registersucctips: "注册成功,请登录",
    companyaccounttips: "该账号已是公司账号,若要注册公司账号,请退出重新注册",
    codesendtips: "已发送",
    codeagain: "获取验证码",
    resetaccountback: "返回上一步",
    resetaccountfirst: "填写账号",
    resetaccountsec: "身份验证",
    resetaccountthr: "设置新密码",
    resetaccountlast: "完成",
    submit: "提交",
    resetphoneaccounttips: "您可以通过有效的绑定手机重置登录密码。",
    resetaccountbyphone: "手机验证重置",
    resetemailaccounttips: "您可以通过有效的绑定邮箱重置登录密码。",
    resetaccountbyemail: "邮箱验证重置",
    resetpwdbyvalide: "验证重置登录密码",
    sendresetpwdcodetips: "力程网已向您绑定的(手机或邮箱)发送了验证码，请查看并输入校验码。",
    resetpwdcodename: "您收到的校验码",
    confirm: "确定",
    invoiceinfo: "",
    yes: "是",
    no: "否",
    invoicemanage: "发票管理",
    invoicerole: "发票角色",
    invoicetype: "发票类型",
    invoicename: "发票抬头",
    identifynumber: "纳税人识别号",
    invoicebankname: "开户银行名称",
    invoicebankaccount: "开户银行账号",
    invoicecompanyadsress: "注册地址",
    invoicecompanyphone: "注册电话",
    invoicelistlefttitle: "已保存",
    invoicelistrighttitle: "条地址",
    updatedate: "修改数据",
    invoicetypetips: "请选择发票类型",
    invoicenametips: "请输入发票抬头",
    identifynumbertips: "请输入纳税人识别号",
    invoicebanknametips: "请输入开户银行名称",
    invoicebankaccounttips: "请输入开户银行账号",
    invoicecompanyadsresstips: "请输入注册地址",
    invoicecompanyphonetips: "请输入注册电话",
    messagetemplatelist: "短信模板列表",
    messagename: "短信名称",
    messagetype: "短信类型",
    messagetemplatename: "短信模板名称",
    messagetemplatetype: "短信模板类型",
    messagetemplatecontent: "短信模板内容",
    updateuser: "修改人",
    disables: "禁用",
    enable: "启用",
    managesetting: "管理设置",
    messagetemplatestatus: "状态",
    addmessagetemplate: "短信模板修改",
    username: "姓     名",
    cardno: "证件号码",
    cardvaliditydate: "有效日期",
    cardincountry: "发证机构",
    cardimg: "证件图片",
    reproveimg: "正面图片",
    deleteimg: "删除图片",
    reverseimg: "反面图片",
    uploadimg: "上传图片",
    companyinfo: "基本信息",
    cardinfo: "证件信息",
    contactinfo: "联系信息",
    customermanage: "客户经理",
    companyname: "公司名称",
    companynickname: "公司简称",
    englishcompanyname: "英文名称",
    companyemail: "公司邮箱",
    companyaddress: "公司地址",
    companytype: "公司类型",
    capitaltype: "资本类型",
    companysize: "公司规模",
    companyprofession: "从事行业",
    companyremark: "备注信息",
    rolecontactpeople: "联系人",
    rolecontactpeoplename: "联系人名称",
    importcontact: "地址导入",
    phoneareacode: "手机区号",
    contactaddress: "联系地址",
    province: "省份",
    city: "城市",
    district: "县区",
    changecompanypeopletips: "提示：接管人接收公司权限后，你将不再具备管理员权限",
    companypeople: "接管人",
    regularcard: "常客卡",
    regularcardno: "卡号",
    disclaimer: "免责",
    fullname: "全称",
    nickname: "简称",
    sex: "性别",
    country: "国籍",
    name: "名称",
    charge: "主管",
    selectcharge: "选择主管",
    companyorgan: "组织结构",
    actionupdatetips: "若不需要设置权限，可以点击保存进入下一步设置,",
    roleaction: "角色权限",
    allemployee: "所有员工",
    roleemployee: "所属员工",
    roleemployeetips: "此员工已在当前部门",
    setmanage: "配置管理",
    workcity: "工作城市",
    workjob: "工作职务",
    workname: "工作用名",
    worktime: "工作时间",
    workdatarang: "查看范围",
    birthday: "出生日期",
    list: "列表",
    createtime: "创建时间",
    startdate: "开始日期",
    enddate: "结束日期",
    sequence: "序号",
    supername: "上级名称",
    updatetime: "修改日期",
    detail: "详细",
    setting: "配置",
    serviceinfo: "服务信息",
    servicename: "服务名称",
    publishname: "发布名称",
    applyarea: "适用区域",
    servicepublic: "是否公开",
    publishservice: "发布服务",
    publishedservice: "服务已发布",
    advancetime: "提前预订时间",
    workperiod: "周期",
    publishsave: "确认发布",
    servicefarelist: "服务费列表",
    servicefarename: "服务费名称",
    servicefareid: "服务费编号",
    companyid: "公司编号",
    servicefarestatus: "服务费状态",
    policystatus: "政策状态",
    customername: "客户名称",
    bookingway: "预订方式",
    workingtime: "工作时间",
    servicefarebyworkingtime: "是否按照工作时间计算",
    money: "元",
    other: "其他",
    fare: "费用",
    roles: "角色",
    jobs: "职称",
    departments: "部门",
    companys: "公司",
    customers: "级别",
    role: "角色",
    job: "职称",
    employee: "员工",
    user: "用户",
    guest: "常客",
    customer: "客户",
    costcenters: "成本中心",
    expenseDepartments: "费用负担部门",
    flowid: "流程编号",
    flowname: "流程名称",
    flowmanage: "流程管理",
    dealpeople: "处理人",
    up: "上移",
    down: "下移",
    langsetting: "语言设置",
    english: "英文",
    japan: "日文",
    china: "中文",
    opened: "已开通",
    closed: "未开通",
    expired: "已过期",
    disable: "已禁止",
    systemsafe: "安全设置",
    downloadtemplate: "下载模板",
    PermissionEmployees: "权限员工",
    GrantDate: "授予日期",
    ExpirationDate: "过期日期",
    saveInfo: "保存信息",
    approvalList: "审批列表",
    StaffName: "员工名称",
    detail: "详情",
    CompanyPage: "公司主页",
    selectCityAgain: "请再选择城市",
    ChooseShipCompany: "选择航司",
    FutureGenerations: "全选",
    TheSelected: "反选",
    QuickFindSelection: "快速查找选择:在此处支持输入多个航司 使用/分割 按Ctrl+Enter键选中",
    shipCompany: "适用航司",
    shipSpace: "选择舱位",
    applySpace: "适用舱位",
    AsOfTheDate: "截止日期",
    AddLevel: "添加级别",
    LevelNames: "级别名称",
    LevelCode: "级别代码",
    RetentionSet: "留扣设置和客户配置",
    LeaveSome: "留点",
    keepMoney: "留钱",
    ServiceLevelAdd: "服务级别添加",
    ProductCategory: "产品类别",
    SubscribeCustomer: "订阅客户",
    SaveButtonSet: "留扣设置",
    localChineseName: "请输入地区中文名称",
    localEnglishName: "请输入地区英文名称",
    PreviewPicture: "图片预览",
    keywordsFilter: "输入关键字进行过滤",
    DataIntegrity: "资料完整度",
    PerfectInformation: "完善资料",
    AuthorizationState: "授权状态",
    accountNumber: "请输入账号",
    DynamicCode: "动态码",
    congratulations: "恭喜",
    ClickNoResponse: "正在跳转至力程商旅平台，6秒内无反应，请点击",
    Here: "这里",
    PasswordChangedSucc: "修改密码成功",
    selectParentDirectory: "请选择上级目录",
  },
  mall: {
    one: "一",
    two: "二",
    three: "三",
    four: "四",
    five: "五",
    six: "六",
    seven: "七",
    eight: "八",
    nine: "九",
    ten: "十",
    contactUs: "联系我们",
    adequateTxt: "充足",
    sheet: "张",
    Remaining: "仅剩",
    ReElectionFlight: "重选航班",
    TaxExclusive: "不含税",
    notificationMessageFlight: "通知：若有需要，可点此进入国际需求单，更多更低价国际机票。满足您的任何差旅需求也可致电：",
    Hotline: "热线咨询。",
    EnfantYears: "2-14岁",
    InfantYears: "两岁以下",
    budget: "经费预算",
    Mylicheng: "我的力程",
    SupportChinese: "支持中文/拼音/简拼输入",
    SupportCode: "支持中文/拼音/简拼/城市代码输入",
    hotCity: "热门城市",
    attendance: "参会人数",
    hostPlace: "举办地点",
    activityBudget: "活动预算",
    PartyNumber: "参加人数",
    internationalHotel: "国际酒店需求单",
    pay: "付",
    NextPage: "下一页",
    PreviousPage: "上一页",
    selected: "已选",
    data: "数据",
    strip: "条",
    paginal: "每页",
    page: "页",
    AuxiliaryWord: "第",
    searchName: "输入名称搜索(点击右侧按钮可添加为临客)",
    keywordsPlaceholder: "输入关键字进行搜索",
    selectName: "选中名称",
    Station: "经停站点",
    TotalAmount: "应付总额",
    checkIn: "入住",
    Broadband: "宽带",
    AttentionPlease: "(特别提醒：请填写违背原因，以便更好的通过审核)",
    TripAgainst: "行程违背了",
    DetailReason: "详情原因",
    ContraryReason: "违背原因",
    Sex: "旅客性别",
    Nationality: "国籍",
    Birthdate: "出生日期",
    Mobile: "联系号码",
    ID: "证件信息",
    PassengerName: "旅客姓名",
    Policy: "差标",
    price: "价格",
    BedType: "床型",
    Window: "窗型",
    ViewsMore: "查看更多",
    durationTime: "历时",
    flightInfo: "航班信息",
    next: "下一步",
    destination: "目的地",
    NoTrainSearch: "当前时段不提供车次查询服务",
    selectedconsumer: "已选旅客",
    btripflow: "差旅审批",
    bookingcenter: "预订中心",
    demandorder: "需求订单",
    selectcompany: "公司选择",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    approvalpolicy: "审批政策",
    bookinguser: "预订员工",
    pleaseselect: "请选择",
    bookingsearch: "查询预订",
    btripaim: "差旅目的",
    budgetCode: "预算编码",
    budgetIntro: "预算描述",
    projectcode: "项目代码",
    bookingtype: "因公因私",
    applyarea: "适用区域",
    serviceset: "服务费配置",
    flowinfo: "审批流程",
    name: "名称",
    flowname: "审批人信息",
    btriprule: "差旅规则",
    priority: "协议优先",
    pricelimit: "价格限制",
    bookinginfo: "预订须知",
    zhtips: "中文提示",
    entips: "英文提示",
    updateorder: "修改订单",
    submitorder: "提交订单",
    tourpasstips: "旅游订单不支持此乘客类型",
    createsucc: "订单创建成功",
    orderapprovalsucc: "订单审核成功",
    pnr: "编码导入",
    flightno: "航班号",
    flightdate: "航班日期",
    airportinfo: "机场信息",
    cabin: "舱位",
    realflight: "实际承运",
    depairportcode: "出发机场三字码",
    arrairportcode: "到达机场三字码",
    hotelname: "酒店名称",
    hotelphone: "酒店电话",
    hoteladdress: "酒店地址",
    hotelarrivedate: "入住日期",
    hoteldepartdate: "离开日期",
    hotelamenddate: "退房日期",
    roomnum: "房间数量",
    roomtype: "房间类型",
    roombedtype: "房间床型",
    breakfast: "早餐",
    consumerDate: "入住时间",
    finishedDate: "离店时间",
    changeamendrule: "退改规则",
    aimcity: "目的城市",
    selectdate: "选择日期",
    keywords: "关键词",
    hotelkeywords: "(选项)酒店名/地标/商圈",
    search: "查询",
    qi: "起",
    searchdetail: "查看详情",
    notReserve: "无可预订房型",
    traffmap: "交通地图",
    sheetzone: "周边街景",
    btripno: "违背规则",
    btripyes: "符合规则",
    room: "房间",
    spec: "平米",
    live: "可住",
    floor: "楼层",
    layer: "层",
    productname: "产品名称",
    averagerate: "日均价",
    breakfastInfos: "餐食信息",
    breakfastyes: "含早",
    breakfastno: "不含早",
    cancelno: "不可取消",
    timecancel: "限时取消",
    plenty: "充足",
    select: "选择",
    hotelfacilities: "酒店设施",
    wifi: "网络连接",
    none: "无",
    parking: "停车场",
    allfacilities: "通用设施",
    activefacilities: "活动设施",
    serviceproject: "服务项目",
    hotelpolicy: "酒店政策",
    depandarr: "入住和离店",
    chdpolicy: "儿童政策",
    mealment: "膳食安排",
    apartment: "公寓",
    theinn: "客栈",
    familyhotel: "家庭旅馆",
    youthhostel: "青年旅舍",
    coupleshotel: "情侣酒店",
    gardencourtyard: "园林庭院",
    seaview: "海景",
    generated: "农家乐",
    hotspringshotel: "温泉酒店",
    golfhotel: "高尔夫酒店",
    siheyuan: "四合院",
    villa: "别墅",
    cookingdinnerparty: "聚会做饭",
    businesstriphome: "商旅之家",
    recreationalfeeling: "休闲情调",
    hospital: "看病就医",
    holidayleisure: "度假休闲",
    traininglearn: "培训学习",
    party: "聚会",
    honeymoontrip: "蜜月出行",
    boutiquehotel: "精品酒店",
    indoorswimmingpool: "室内游泳池",
    outdoorswimmingpool: "室外游泳池",
    gym: "健身房",
    businesscenter: "商务中心",
    meetingroom: "会议室",
    hotelrestaurant: "酒店餐厅",
    wakeupcall: "叫醒服务",
    luggage: "行李寄存",
    doublebed: "双床",
    bigbed: "大床",
    pickupservice: "接机服务",
    pet: "宠物",
    creditcard: "信用卡",
    username: "姓名",
    usersex: "性别",
    PassengerType: "旅客类型",
    cardtype: "证件类型",
    cardno: "证件号码",
    contactphone: "联系电话",
    birthday: "出生日期",
    usercountry: "国籍",
    cardvaliditydate: "证件有效期",
    add: "添加",
    delete: "删除",
    passselect: "选择旅客",
    contactpeople: "联系名称",
    contactemail: "联系邮箱",
    salesprice: "销售价",
    marketprice: "市场价",
    supplyprice: "结算价",
    tourdepcity: "出发地",
    tourarrcity: "目的地",
    teamno: "团号",
    tourdepdate: "出游日期",
    remark: "备注",
    traininfo: "车次信息",
    trainno: "车次号码",
    trainseattype: "座位等级",
    traindepdatetime: "发车时间",
    trainarrdatetime: "到达时间",
    traindepdate: "出发日期",
    amendtime: "退改签时限",
    moneysourceairway: "以航空公司最新规定为准，可咨询客服电话",
    amendruletips: "以上成人退改签规则及费用标准，仅供参考，实际需以航司为准",
    adultticket: "成人票",
    amendfee: "退票费",
    samechangefee: "同舱改期费",
    changecondition: "签转条件",
    changeadopt: "允许转签",
    people: "人",
    completechange: "已变更完成",
    reimburseinfo: "报销信息",
    travleorderinfo: "可提供全额行程单",
    travleinvoince: "提供差额发票和行程单",
    bagkg: "行李额",
    forfeebagkg: "免费托运行李额20KG",
    realtake: "实际乘坐",
    realtaketips: "请按实际乘坐航班办理值机。",
    share: "共享",
    airplanemodel: "机型",
    isstop: "经停",
    allprice: "全价",
    discount: "折",
    protocolprice: "商务推荐",
    build: "机建",
    fuel: "燃油",
    booking: "预订",
    flightok: "确定",
    allprices: "更多价格",
    flightnum: "张",
    flightnumtips: "仅剩",
    flightgo: "去程",
    flightback: "回程",
    flightdetail: "航班详情",
    totalmoney: "总金额",
    flightticket: "国内机票",
    iflightticket: "国际机票",
    screening: "筛选条件",
    clear: "清空",
    flightvuelo: "直飞/中转",
    flightdeptimes: "起飞时段",
    airways: "航空公司",
    depairport: "起飞机场",
    arriveairport: "到达机场",
    checkflightgo: "已选去程",
    changeflight: "修改航班",
    flightlisttips: "条航班信息",
    flightdeptime: "起飞时间",
    flightarrtime: "到达时间",
    flightprice: "价格",
    nostop: "直飞",
    transfer: "中转{city}（等待：{time}）",
    TransferVoyage: "中转",
    NostopOrTransfer: "直飞/中转",
    ShareFlight: "共享航班",
    HideShareFlight: "隐藏共享航班",
    am: "上午",
    noon: "中午",
    pm: "下午",
    firstcabin: "头等舱",
    businesscabin: "商务舱",
    economycabin: "经济舱",
    createflightorder: "确认，下一步",
    loading: "加载中......",
    flightpricechange: "航班价格有变动请确认后下单！",
    tips: "提示",
    confirm: "确认",
    flightbookingtitel: "我的力程",
    flightbooking: "机票预订",
    orderdetail: "订单信息",
    contactinfo: "联系人信息",
    taketicketway: "取票方式",
    departcity: "出发城市",
    arrivecity: "到达城市",
    departdate: "出发时间",
    arrivedate: "到达时间",
    backdate: "返程时间",
    loginuser: "当前用户",
    priceway: "报价方式",
    pricestips: "本页面提供的机票为净价,不含服务费。",
    firtransfer: "1程中转",
    sectransfer: "2程中转及以上",
    transfercitys: "中转城市",
    economy: "经济舱",
    business: "商务舱",
    first: "头等舱",
    premiumecon: "超级经济舱",
    premiumebus: "超级商务舱",
    premiumefirst: "超级头等舱",
    iflightcitytips: "请选择国际城市！",
    approvalSelectCitytips: "起飞到达城市要有一项所属审批单航程！",
    approvalDepartDatetips: "出发日期要符合审批单日期区间！",
    approvalArriveDatetips: "出发/返程日期要符合审批单日期区间！",
    approvalSelectHotelCitytips: "目的城市要所属审批单行程！",
    iflightbookingtips: "您选定的航班机票仅剩",
    policyyes: "符合规则",
    policyno: "违背规则",
    priceandtax: "含税",
    stoptime: "经停时间",
    hotel: "酒店",
    hotelpeoplenum: "入住人数",
    hoteldeskphone: "前台电话",
    hotelleveltitle: "星级从高到低排序",
    hotelpricetitle: "价格从高到低排序",
    below: "以下",
    above: "以上",
    hotelstart: "二星及以下",
    threehotelstart: "三星级/舒适",
    fourhotelstart: "四星级/高档",
    fivehotelstart: "五星级/豪华",
    position: "位置",
    nolimit: "不限",
    adminregion: "行政区",
    businesszone: "商业区",
    startlevel: "星级",
    contractHotel: "协议酒店",
    huazhuHotel: "华住酒店",
    feature: "特色",
    facilities: "设施",
    service: "服务",
    hotelcounttips: "家酒店",
    hotelcountall: "共",
    hotelinfoorstart: "酒店信息/星级",
    hotelinfo: "酒店信息",
    referprice: "参考价",
    reselect: "重新选择",
    chinahotel: "国内酒店",
    interhotel: "国际酒店",
    bookinghotel: "酒店预订",
    hotelbookinginfo: "预订信息",
    depandarrdate: "入离日期",
    night: "晚",
    insure: "保险",
    hotelroomtype: "房型",
    hotelproductcount: "更多产品",
    chinatrain: "国内火车",
    trainbooking: "火车票预订",
    trainusernametip: "姓名不能为空",
    trainusercardtip: "请完善证件信息",
    trainrecard: "身份证不能重复",
    trainseatin: "预订成功，正在占座",
    selectseatfree: "免费选座",
    selectedseat: "已选座",
    noselectseat: "未选座",
    trainwindow: "窗",
    aisie: "过道",
    trainseattips: "优先按指定坐席出票，若所选坐席无票时，将转购其他坐席",
    change: "换",
    timelength: "时长",
    trainticketnum: "余票数",
    trainchangamendinfo: "退改签说明",
    traindepandarrstation: "发/到站",
    traindepandarrtime: "发/到时间",
    trainlogin12306tip: "关联12306账号，直连铁路官方系统，出票更快速！",
    login: "登陆",
    account: "账号",
    login12306user: "12306用户名",
    login12306pwd: "请输入密码",
    loginerror: "用户名或密码错误",
    loginout: "退出",
    logintip: "已登录",
    btripinfo: "商旅信息",
    shenpipingzheng: "审批凭证",
    youshenpipingzheng: "有审批凭证",
    wushenpipingzheng: "无审批凭证",
    shenpizhuangtai: "审批状态",
    chuchaishenqingiworkyishenpi: "出差申请Iworker已审批",
    shangweishenpi: "尚未审批",
    shenpidanhao: "审批单号",
    yijishenpi: "级审批",
    shangchuanfujian: "上传附件",
    fujianliebiao: "附件列表",
    inputcontent: "请输入内容",
    btripordertip: "以下行程违背差旅政策,需补充违背原因",
    btriporderttip: "(特别提醒：请填写违背原因，以便更好的通过审核)",
    ordervoyage: "行程",
    violate: "违背了",
    policydetail: "的政策",
    policynoreason: "违背政策原因",
    policyreasondetail: "详细违背原因",
    consumerinfo: "旅客信息",
    consumernametip: "姓名，请与登机证件保持一致",
    phoneareano: "中国大陆区号",
    phonenotips: "乘机人手机号，用于接收航班动态信息",
    saveconsumer: "保存为常客",
    selectconsumer: "选择乘客",
    addconsumer: "添加乘客",
    consumertip: "重要提醒：为了确保出行，请准确填写证件号以及有效期，旅行结束日比证件到期日须至少早6个月。",
    writeinfomation: "填写说明",
    demandremark: "需求备注",
    welcomelogin: "欢迎登陆",
    registernow: "企业注册",
    loginbyaccount: "账号密码登录",
    loginbyphone: "手机动态码登录",
    loginbyother: "您还可以使用以下方式登录",
    wechat: "微信",
    addressinfo: "地址信息",
    Add: "添加",
    defaultcontact: "默认地址",
    settingdefaultcontact: "设为默认地址",
    edit: "编辑",
    contactpeople: "联系姓名",
    contactphone: "联系手机",
    contactemail: "联系邮箱",
    adddemand: "需求录入",
    voyagetype: "航程类型",
    consumertype: "乘客类型",
    adult: "成人",
    child: "儿童",
    infant: "婴儿",
    firstflightsearchtips: "乘客总数（不含婴儿）多于9人，请填写",
    flightdemandorder: "机票需求单",
    lastflightsearchtips: "进行预订。",
    firstiflightsearchtips: "每名成人最多可携带2名儿童和1名婴儿乘机，如有特殊需求，请至",
    adminregionhotel: "港澳台",
    unsubmit: "未提交",
    submited: "已提交",
    chenking: "审核中",
    paymoney: "已付款",
    etdzticket: "已出票",
    directclose: "成交",
    searchtrainbytraintype: "只搜高铁动车",
    selectfrequent: "选择常客",
    frequent: "常客",
    addtemporaryconsumer: "添加临客",
    home: "首页",
    tour: "旅游",
    train: "火车",
    flight: "机票",
    car: "租车",
    food: "美食",
    btripplateform: "差旅平台",
    comcoop: "企业合作",
    appdownload: "App下载",
    meeting: "会展",
    visa: "签证",
    tourism: "会议旅游",
    stationname: "车站名",
    trainstoptime: "停留时间",
    stopstationname: "经停站",
    soldout: "售完",
    start: "始",
    over: "过",
    end: "终",
    yu: "余",
    trainbatch: "车型",
    startorvoer: "始发过路",
    startstation: "始发车站",
    endstation: "到达车站",
    changeticket: "车票改签",
    pleasepasstochange: "请选择需要改签的乘客",
    pleaseselectnewdate: "请选择改签日期",
    oldtraininfo: "原车次信息",
    gctrain: "G/C高铁",
    dtrain: "D动车",
    ptrain: "普通",
    traindeptime: "出发时段",
    trainarrtime: "到达时段",
    trainstart: "始发",
    trainover: "过路",
    hour: "小时",
    minute: "分钟",
    trainchangeinfo: "改签车次信息",
    changetrain: "更改车次",
    changefee: "改签费用",
    changeservicefee: "改签服务费",
    totalfee: "合计",
    changereason: "改签原因",
    checking: "待审核",
    boyin: "波音",
    kongke: "空客",
    zhuanxiangjia: "专享价",
    analysis: "旅客解析",
    contact: "联系人",
    bigcus: "大客户",
    airway: "航司",
    selectcom: "请先选择公司",
    nameisetm: "旅客名称不能空",
    writenametype: "请输入正确的姓名(Chen/Wenjun)",
    baoxianset: "保险配置",
    saleandcus: "销售/客服代表",
    recommendair: "推荐航班",
    more: "更多",
    hide: "隐藏",
    triprulename: "差旅政策",
    hightsearch: "高级搜索",
    cabinlevel: "舱位等级",
    submitapply: "提交申请",
    interdemand: "国际及港澳台航班需求单",
    alltotal: "共有",
    demandcus: "如有疑问，您可联系客服。我们会及时为您解决相关问题。",
    voyageinfos: "航程信息",
    addvoyage: "添加航程",
    passinfos: "乘客信息",
    passnum: "乘客人数",
    sui: "岁",
    twosui: "两岁以下",
    firstairway: "首选航空公司",
    phoneno: "手机号码",
    email: "邮箱",
    submit: "提交",
    demandprobtip: "如提交出现问题请咨询：",
    normal: "普通",
    student: "学生",
    newimmigrant: "新移民",
    worker: "劳务",
    submitordersucc: "订单提交成功",
    hotelfare: "房费",
    contservicefee: "含服务费",
    hotelinfoimp: "酒店导入",
    addhotel: "添加酒店",
    inputprice: "请输入正确的金额",
    inputpriceerror: "最大金额不能小于或等于最小金额",
    starrankdesc: "星级按推荐排序",
    starrank: "星级从高到低排序",
    starrankasc: "星级从低到高排序",
    pricesort: "价格从高到低排序",
    pricesortdesc: "价格从低到高排序",
    clickrecomend: "点击按推荐",
    caclhotelprice: "正在核算价格......",
    none: "无",
    freebroadbang: "免费宽带",
    broadband: "收费宽带",
    freewifi: "免费WIFI",
    wifi: "收费WIFI",
    imgshow: "图片显示",
    additinfos: "附加信息",
    insurinfos: "保险信息",
    surname: "姓",
    givenname: "名",
    orderpassup: "单张订单旅客上限为",
    orderpassupend: "人,需更多请联系客服！",
    cabintype: "舱位类型",
    selectcabin: "选择舱位",
    safetrip: "安心出行,",
    downloadapp: "下载力程商旅APP",
    selectchangepass: "请选择旅客！",
    searchpassup: "最多只能9个旅客！",
    selectcontact: "选择联系人",
    cancel: "取消",
    tourindextip: "满足您的商旅服务需求，并致力于为商旅客户提供全方位的服务解决方案。",
    tourdetailcall: "详情咨询",
    yearmeet: "年会",
    yearmeettips: "全程跟踪服务打造最高端的企业年会",
    comyearmeet: "公司年会",
    comtourtips: "针对企业需求定制最舒适的旅游行程",
    comtour: "公司旅游",
    teambuild: "团建",
    teambuildtips: "为企业提供个性化定制户外团建服务",
    createteambuild: "团建策划",
    exhibit: "会展",
    exhibittips: "为客户提供一站式会议策划执行服务",
    comexhibit: "会务会展",
    trainordercretips: "一张订单最多添加5名乘客，如有更多人出行，请联系客服或另行下单预订。",
    trainpassrepeat: "乘客名不能重复。",
    trianorderpassup: "最多只能选择5个乘客。",
    inputpassgivenname: "请输入乘客名。",
    inputpasssurname: "请输入乘客姓。",
    trainpassseattips: "乘客人数超过选择座位数",
    aisle: "过道",
    NeedInvoice: "需要发票",
    NoInvoice: "不要发票",
    delway: "配送方式：",
    exprefee: "快递费用：",
    addresspass: "收件人",
    postcode: "邮政编码",
    deladdress: "配送地址",
    inputphoneno: "请输入手机号码",
    inputphonerealno: "请输入正确的手机号码",
    inputtickettitle: "请输入发票抬头",
    inputaddresspass: "请输入收件人",
    inputdeladdress: "请输入收件地址",
    Invite: "自取",
    Mail: "邮件",
    nothing: "不需要",
    parper: "纸质发票",
    tourservicefee: "旅游服务费",
    express: "快递",
    ticketfare: "票面",
    trainnamecardtips: "姓名，请与乘车证件姓名保持一致",
    phonecountry: "中国大陆区号86",
    phoneinfotips: "乘车人手机号，需要接受手机短信号",
    savecuspass: "保存为常旅客",
    triprulemanage: "差旅管理",
    trainorderseat: "请为已选择的旅客选择座位",
    createordernow: "立即预订",
    parenter: "合作伙伴",
    aboutus: "关于我们",
    companyinfo:
      "力程商旅是中国领先的差旅管理公司，隶属于力程集团，十年来，依靠强大的资源、先进的技术、优质的服务和专业的管理，为包括120余家世界五百强和100余家中国五百强在内的6000多家中大型企业提供服务。",
    companywechat: "关注力程商旅公众号",
    companyname: "力程商旅",
    simple: "越简单",
    free: "越自由",
    lowermoney: "越省钱",
    traintuiinfo: "退票说明",
    traintuiinfo1:
      "1：代购成功，未取票且发车前时间大于35分钟，可进入“我的订单”，点击火车订单根据提示申请退票；发车前8天以内的退票，铁路局将对每张车票按梯次收取退票手续费。",
    traintuiinfo2: "2：代购成功，已取票或发车前时间小于35分钟，需您自行携带购票时所使用的乘车人有效证件原件和火车票在发车前去火车站退票窗口办理退票。",
    trainchanginfo: "改签说明",
    trainchanginfo1: "1：未取纸质票，且离发车时间大于35分钟，可改签等于或低于原车票票价的车次。其他不能在线改签的情况需在发车前至火车站窗口办理。",
    trainchanginfo2: "2：开车前48小时以上，可改签预售期内的车次。开车前48小时以内，可改签至票面当天24：00之前任意车次，不办理票面日期次日及以后的改签",
    trainchanginfo3: "3：新车票票价低于原车票的，退还差额，对差额部分核收退票费并执行现行退票费标准。",
    datetimenotrain: "当前日期车票未开售",
    ReserveHint: "当前为非联程航班，如遇其中一程航班变动，另一程若需办理退改乘客需自行承担相应退改费用。",
    chailvguize: "差旅规则名称",
    guonei: "国内",
    guojie: "国际",
    jipiao: "机票",
    jiudianguize: "酒店规则",
    huoche: "火车",
    guize: "规则",
    zuidijiajizhun: "最低价格基准",
    wuxianzhi: "无限制",
    xiangduizuidijia: "相对最低价",
    quantianzuidijia: "全天最低价",
    shiduanzuidijia: "时段最低价",
    hangbanzuidijia: "航班最低价",
    shishihangbanguankong: "实时航班管控",
    tiqianyudingshijian: "提前预订时间",
    kedingcangweijibie: "可订舱位级别",
    kedingzuoweijibie: "可订座位级别",
    xieyijipiaoyouxian: "协议机票优先",
    xieyijiudianyouxian: "协议酒店优先",
    xiaofeijineshangxian: "消费金额上限",
    dangdizhusubiaozhunshangxian: "当地住宿费标准上限",
    yudingxuzhi: "预订须知",
    dingpiao: "订票",
    tuipiaochongkai: "退票重开",
    xuanweiqucheng: "选为去程",
    yes: "是",
    no: "否",
    firstcity: "1级城市",
    seccity: "2级城市",
    thrcity: "3级城市",
    within: "以内",
    qxzhsrxmdm: "请选择或输入项目代码",
    qxzxmdm: "请选择项目代码",
    weibeixiaofeijineshangxian: "消费金额上限",
    dangdizhusubiaozhun: "当地住宿费标准",
    youchuang: "有窗",
    weichuang: "无窗",
    qianmianfeiquxiao: "前免费取消，",
    zhihoubukequxiao: "之后不可取消",
    wuzao: "不含早",
    nights: "共{number}晚",
  },
  manage: {},
  bill: {
    bankaccount: "银行账户",
    acronym: "简称",
    select: "请选择",
    query: "查询",
    added: "添加",
    export: "导出",
    companyname: "公司名称",
    inorout: "收支类型",
    accountstatus: "账户状态",
    operation: "操作",
    enable: "启用",
    disable: "禁用",
    update: "修改",
    content: "请输入内容",
    cancel: "取消",
    save: "保存",
    confirm: "确定",
    accountadded: "账户添加",
    accountupdate: "账户修改",
    enableordisableprompt: "此操纵用于禁用或启用, 是否继续?",
    prompt: "提示",
    receivebill: "应收账期",
    bill: "账期",
    closeaccountprofit: "关账毛利",
    comparisonsales: "销量对比",
    closeaccountstarttime: "关账开始日期",
    starttime: "开始日期",
    closeaccountendtime: "关账截至日期",
    endtime: "截至日期",
    clientname: "客户名称",
    customerservicerepresentative: "客服代表",
    salesrepresentative: "销售代表",
    number: "条数",
    closeaccountprofittotel: "关账毛利合计",
    inadditioninterestprofit: "除利息后毛利",
    receiveprice: "应收金额",
    actualprofit: "实际毛利",
    profitrate: "毛利率",
    interest: "利息",
    additioninterestprofit: "利息后毛利",
    additioninterestprofitrate: "利息后毛利率",
    profitprecent: "毛利占比",
    back: "<<返回",
    Internationalflight: "国际机票",
    internalflight: "国内机票",
    Internationalhotel: "国际酒店",
    internalhotel: "国内酒店",
    internaltrain: "国内火车",
    selectyearmonth: "选择年月",
    tradebill: "交易账期",
    agreedpaystarttime: "约定结账开始日",
    agreedpayendtime: "约定结账结束日",
    billdate: "账单日期",
    billdateend: "截至日期",
    agreedpaydate: "约定结账日",
    waitoutday: "未出帐",
    waitaudited: "未审核",
    waitconfirm: "未确认",
    amountshouldbeclosed: "应结金额",
    detail: "详细",
    total: "合计",
    createtime: "创建日期",
    orderid: "订单编号",
    businesstype: "业务类型",
    servicetype: "服务类型",
    paymentincludinginsurancecharge: "应付(含服务/保险费)",
    passengername: "旅客名称",
    bookingname: "预订人",
    productname: "产品名称",
    billaggregate: "账期汇总",
    billdetail: "账期明细",
    size: "大小",
    amountreceivable: "未收金额",
    allstatus: "所有状态",
    billname: "账期名称",
    expiretime: "到期日期",
    overdueday: "逾期(天数)",
    receivable: "应收",
    havebeentaken: "已收",
    notreceive: "未收",
    profit: "毛利",
    totalaccountingperiod: "账期外总额",
    invoicestatus: "发票状态",
    statusdetail: "状态(明细数)",
    Updates: "更新",
    receivedetail: "应收明细",
    createstarttime: "创建开始日期",
    createendtime: "创建截至日期",
    receivestarttime: "收款开始日期",
    receiveendtime: "收款截至日期",
    paymentstarttime: "付款开始日期",
    paymentendtime: "付款截至日期",
    applyarea: "区域类型",
    supplyid: "供应单号",
    supplyname: "供应名称",
    voucherno: "凭证号",
    intentname: "差旅目的",
    projectcode: "项目代码",
    invoiceid: "发票编号",
    template: "模板",
    templatemanager: "模板管理",
    fullscreen: "全屏显示",
    quanping: "退出全屏",
    orderselect: "订单勾选",
    receivestatus: "收款状态",
    invoiceapplication: "发票申请",
    receiveaudit: "收款审核",
    receiveconfirm: "收款确认",
    losstreatment: "亏损处理",
    receivefinished: "收款关账",
    receiveaudited: "收款退回",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    supplyName: "供应名称",
    bulkEditingSupplyName: "批量修改供应名称",
    all: "全部",
    paymentstatus: "付款状态",
    obligation: "待付款",
    paymentaudit: "付款审核",
    paymentconfirm: "付款确认",
    paymentfinished: "收款关账",
    paymentaudited: "收款退回",
    orderselecttext: "请输入需要勾选的订单号码(用空格、换行或逗号分隔)",
    receivefaila: "请先进行客户查询在进行该操作",
    receivefailb: "请勾选需要操作的明细",
    receivefailc: "请选择正确的数据",
    receivefaild: "请先预设供应名称",
    invoiceapplyfaila: "请选择没有提交发票申请的数据",
    order: "订单",
    losstreatmentfail: "。关账毛利超过10%或低于10%,请先进行亏损处理。",
    loading: "正在执行操作......",
    orderselectfail: "请输入您要勾选明细的订单号码",
    tradedetail: "交易明细",
    templatename: "模板名称",
    rightmove: "右移",
    leftmove: "左移",
    topmove: "上移",
    bottommove: "下移",
    rightfaila: "请选择要右移的数据",
    leftfaila: "请选择要左移的数据",
    topfaila: "该数据不能进行上移操作",
    bottomfaila: "该数据不能进行下移操作",
    templatfaila: "请选择一条数据进行上下移动",
    costcenternamesearch: "成本名称搜索",
    expenseDepartmentNameSearch: "费用负担部门名称搜索",
    supplyNamesearch: "供应名称搜索",
    billnamesearch: "账期名称搜索",
    receivetablefaila: "请选择成本中心",
    selectExpenseDepartment: "请选择费用负担部门",
    receivetablefailb: "请先退出重新修改",
    receivetablefailc: "请选择账期",
    receivetablefaild: "请选择供应名称",
    profitandlossreasons: "盈亏原因",
    lossreasons: "亏损原因",
    profitreasons: "盈利原因",
    reakeven: "无亏损",
    losscausefaila: "请选择亏损原因",
    invoiceitemname: "项目名称",
    invoiceitemmodel: "规格型号",
    invoiceitemunitname: "单位",
    invoiceitemnum: "数量",
    invoiceitemfare: "单价",
    invoiceitemcost: "成本",
    invoiceitemamount: "金额",
    invoiceitemrate: "税率",
    invoiceitemtax: "税额",
    delete: "删除",
    invoicetitle: "发票抬头",
    invoicetype: "发票类型",
    clientadress: "客户地址",
    clientemail: "客户邮箱",
    remark: "备注",
    invoiceapplyfailb: "请输入正确的单价",
    invoiceapplyfailc: "请输入正确的税率",
    invoiceapplyfaild: "提交发票价格不能大于原发票价格",
    invoiceapplyfaile: "发票申请成功",
    accountname: "账户名称",
    accounttype: "账户类型",
    tradeaccountlistfaila: "请输入正确的金额",
    tradeaccountlistfailb: "充值录入成功",
    tradeaccountlist: "账户列表",
    availablebalance: "可用余额",
    accountbalance: "账户余额",
    creditbalance: "信用额度",
    blockedamount: "冻结金额",
    flow: "流水",
    recharge: "充值",
    blockedtransactions: "交易冻结",
    tradename: "交易名称",
    freezingtime: "冻结时间",
    creditline: "授信额度",
    contractdate: "合同日期",
    creditaddedprompt: "固定授信额度有效期以合同日期为准,如过期请续约",
    provisionalcredit: "临时授信",
    effectivedate: "生效日期",
    expirydate: "失效日期",
    lodamt: "充值金额",
    transactionflowing: "交易流水",
    tradedate: "交易日期",
    flowtype: "流水类型",
    transactionamount: "交易金额",
  },
  webdata: {
    interfaceManage: "配置管理",
    ChangeCheckPNR: "编码检验",
    insuranceamend: "退款处理",
    orderlist: "订单列表",
    mallservice: "商城服务",
    wechat: "微信管理",
    dealwarranty: "保单处理",
    insuranceorder: "保险订单",
    insuranceservice: "保险服务",
    insurancepolicy: "保险政策",
    changruletime: "变更时限",
    baggagerule: "行李额规则",
    departmanage: "部门管理",
    see: "查看",
    oftenconsumermanage: "常客管理",
    oftenconsumer: "常用旅客",
    costcenter: "成本中心",
    expenseDepartment: "费用负担部门",
    deal: "处理",
    waitdispos: "待处理",
    waitdispose: "待处理",
    waitpayment: "待付款",
    waitconfirm: "待确认",
    waitthrowin: "待审核",
    waitapprove: "待审批",
    waitsubmit: "待提交",
    waitrefund: "待退款",
    waitbooking: "待预订",
    addressmanage: "地址管理",
    dealorder: "订单处理",
    ordermanage: "订单管理",
    subservice: "订阅服务",
    dealinvoice: "发票处理",
    inviceservice: "发票服务",
    invoicemanage: "发票管理",
    servicefeesetting: "服务费设置",
    servicemanage: "服务管理",
    serviceinfo: "服务信息",
    interfaceinfo: "接口配置",
    payment: "付款",
    dealpayment: "付款处理",
    peoplemanage: "个人管理",
    companysetting: "公司配置",
    internationflight: "国际机票",
    internationhotel: "国际酒店",
    internationaltour: "国际旅游",
    chinatraffic: "国内用车",
    chinatrain: "国内火车",
    chinaflight: "国内机票",
    chinahotel: "国内酒店",
    chinatravel: "国内旅游",
    trainorder: "火车订单",
    flightorder: "机票订单",
    trafficorder: "订单处理",
    basedata: "基础数据",
    transaction: "交易明细",
    tradereceive: "应收明细",
    tradepayment: "交易明细",
    smstemplate: "短信模板",
    datastatistics: "数据统计",
    tradeweek: "交易账期",
    billreceive: "应收账期",
    billpayment: "交易账期",
    hotelorder: "酒店订单",
    customermanage: "客户管理",
    customerlevel: "客户级别",
    dealdelivery: "快递处理",
    deliveryservice: "快递服务",
    deliverypolicy: "快递政策",
    flowmanage: "流程管理",
    tourorder: "旅游订单",
    companymanage: "企业管理",
    companyinfo: "企业信息",
    companyhome: "企业主页",
    visaorder: "签证订单",
    visaservice: "签证服务",
    allorder: "全部订单",
    purviewmanage: "权限管理",
    purviewcontrol: "权限控制",
    approve: "审批",
    dealmoneyin: "收款处理",
    moneynandoutmanage: "收支管理",
    authorizemanage: "授权管理",
    amendorder: "退改订单",
    changeamendrule: "退改规则",
    clientuser: "大客户",
    domainmanage: "域名管理",
    notifymanage: "通知管理",
    dealrefund: "退款处理",
    dealamend: "退票处理",
    dealamendorder: "退票处理",
    dealamendtour: "退团处理",
    webmanage: "网站管理",
    mineinfo: "我的信息",
    usermain: "我的主页",
    systemmanage: "系统管理",
    discrete: "已拆分",
    forbiddened: "已禁用",
    canceled: "已取消",
    throwined: "已上线",
    rejected: "已退回",
    rejectes: "已退回",
    finished: "已完成",
    finishes: "已完成",
    hanguped: "已下线",
    bankaccount: "银行账户",
    coupon: "优惠券",
    employeemanage: "员工管理",
    cannnot: "暂不能",
    cannot: "暂不能",
    accountsafe: "配置管理",
    accountmanage: "账户管理",
    tradeaccount: "企业账户",
    financemanage: "账务管理",
    policymanage: "政策管理",
    policymangage: "政策管理",
    jobmanage: "职位管理",
    businessservice: "商旅服务",
    chargeservice: "增值服务",
    chargepolicy: "服务政策",
    feedback: "意见反馈",
    mallservice: "商城服务",
    orderlist: "订单列表",
    sharelist: "活动管理",
    orderchange: "航变列表",
    smsnotify: "通知列表",
    supplylist: "供应管理",
  },
  category: {
    AmendingFlight: "部分退票中",
    ChangeingFlight: "部分改签中",
    AmendingTrain: "部分退票中",
    ChangeingTrain: "部分改签中",
    AmendingHotel: "部分退房中",
    ChangeingHotel: "部分改签中",
    AmendingTour: "部分退团中",
    ChangeingTour: "部分改签中",
    AmendedFlight: "部分退票",
    ChangeedFlight: "部分改签",
    AmendedTrain: "部分退票",
    ChangeedTrain: "部分改签",
    AmendedHotel: "部分退房",
    ChangeedHotel: "部分改签",
    AmendedTour: "部分退团",
    ChangeedTour: "部分改签",
    AllAmendingFlight: "退票中",
    AllChangeingFlight: "改签中",
    AllBookingFlight: "购票中",
    AllAmendingTrain: "退票中",
    AllChangeingTrain: "改签中",
    AllBookingTrain: "购票中",
    AllAmendingHotel: "退房中",
    AllChangeingHotel: "改签中",
    AllBookingHotel: "预订中",
    AllAmendingTour: "退团中",
    AllChangeingTour: "改签中",
    AllBookingTour: "预订中",
    AllAmendedFlight: "退票成功",
    AllChangeedFlight: "改签成功",
    AllBookedFlight: "购票成功",
    AllAmendedTrain: "退票成功",
    AllChangeedTrain: "改签成功",
    AllBookedTrain: "购票成功",
    AllAmendedHotel: "退房成功",
    AllChangeedHotel: "改签成功",
    AllBookedHotel: "预订成功",
    AllAmendedTour: "退团成功",
    AllChangeedTour: "改签成功",
    AllBookedTour: "预订成功",
    "1672category": "房费",
    "1674category": "团费",
    "1660category": "票面",
    "1662category": "机建",
    "1664category": "燃油",
    "1666category": "税费",
    "1692category": "直减",
    "1668category": "保险",
    "1670category": "服务费",
    "1678category": "退票",
    "1682category": "变更",
    "1684category": "原价",
    "1690category": "其它",
    "1694category": "折扣",
    Conference: "会议",
    EnterprisesUnit: "企事业单位",
    GovernmentDepartment: "政府机关",
    PeopleEnterprises: "民营资产",
    CountryCapital: "国有资产",
    ChinaOuterJoinCapital: "中外合资",
    ForeignCompany: "外商独资",
    CompanySize100: "100人以下",
    CompanySize499: "100~499",
    CompanySize999: "500~999",
    CompanySize4999: "1000~4999",
    CompanySize5kUp: "5000以上",
    Internal: "国内",
    Overseas: "国际",
    IDCard: "身份证",
    PassportCard: "护照",
    StudentCard: "学生证",
    OfficerCard: "军人证",
    OtherCard: "其它",
    Residencepermit: "港澳台居民居住证",
    ForeignResidentIDCard: "外国人永久居留身份证",
    HKCompatriotsyndrome: "港澳通行证",
    TaiCompatriotsyndrome: "台湾通行证",
    Enable: "启用",
    UnEnable: "禁用",
    Male: "男",
    Female: "女",
    Yes: "是",
    No: "否",
    SingleVoyage: "单程",
    RoundVoyage: "往返",
    ReturnVoyage: "回程",
    MultiVoyage: "多程",
    TransferVoyage: "中转",
    BSP: "BSP",
    B2B: "B2B",
    OverseasElectronic: "境外电子 ",
    ConnectVoyage: "联程 ",
    Team: "团队",
    Fit: "散客",
    Unlimited: "不限",
    HighOpen: "高开",
    DownOpen: "低开",
    Monday: "星期一",
    Tuesday: "星期二",
    Wednesday: "星期三",
    Thursday: "星期四",
    Friday: "星期五",
    Saturday: "星期六",
    Sunday: "星期日",
    WithinIntercontinental: "同一洲际范围内",
    PolicyDepartAirport: "政策始发机场范围",
    NoReward: "无奖励 ",
    AgencyFreeFee: "无代理费",
    MustBackAirport: "必须返回行程出发机场",
    AppointBackAirport: "指定返回国家或机场范围",
    CommonFlight: "普通航班",
    ShareFlight: "共享航班",
    Prepay: "预付",
    CashPay: "现付",
    OverseasStudent: "留学生 ",
    Immigrant: "移民",
    Worker: "劳工",
    Seaman: "海员",
    Youth: "青年",
    HkMacaoTw: "港澳台",
    ForeignNationality: "外籍 ",
    NotChineseName: "非汉字姓名",
    AddOn: "Add-On",
    OldGge: "老年 ",
    OverseasTransfer: "境外中转 ",
    NotchRange: "缺口程 ",
    OPEN: "OPEN",
    SPA: "SPA",
    QValue: "Q值",
    SharedFlight: "共享航班 ",
    ThreeAgreement: "三方协议 ",
    Package: "套票",
    WholeGroup: "整团",
    SmallGroup: "小团 ",
    RewardsAdults: "奖励与成人一样",
    NoOpenBonus: "可无开奖励 ",
    WithoutReward: "可开无奖励",
    NotOpen: "不可开 ",
    NoCodingRequired: "无需还编码 ",
    CodeOut: "换编码出票 ",
    BigTicket: "大编出票（ 无需换编） ",
    BigNoTicket: "大编出票（需换编）",
    NoChange: "无位不换出票（外放有位时换编）",
    // SingleVoyage: "单程",
    // RoundVoyage: "往返",
    SingleRound: "单程/往返",
    MonthCycle: "月",
    WeekCycle: "周",
    DayCycle: "日",
    HKMpermit: "回乡证",
    TaiWpermit: "台胞证",
    OnlineServiceMode: "线上服务",
    LineServiceMode: "线下服务",
    PercentageMode: "百分比",
    FixedPrice: "固定金额",
    ExpensePrice: "票面价",
    PriceFareAndTax: "票面价+税费",
    DirectUpdate: "直接修改",
    AddLittle: "加点",
    ReduceLittle: "减点",
    User: "用户",
    Jobs: "职称",
    Group: "群组",
    Department: "部门",
    Company: "公司",
    Service: "服务",
    Customer: "客户",
    Actions: "权限",
    CostCenter: "成本中心",
    ExpenseDepartment: "费用负担部门",
    Server: "服务端",
    Client: "客户端",
    Normal: "正常",
    Change: "变更",
    SelfOnly: "仅自己",
    SelfLower: "自己及下级",
    NoLimit: "不限制",
    UnAuthorized: "未授权",
    Authorized: "已授权",
    SystemRole: "系统角色",
    UserRole: "用户角色",
    ContinueBefore: "继续之前",
    ContinueAfter: "继续之后",
    ReturnBefore: "退回之前",
    ReturnAfter: "退回之后",
    ChangeBefore: "变更之前",
    ChangeAfter: "变更之后",
    NeedInvoice: "需要发票",
    NoInvoice: "不要发票",
    WEB: "网站",
    RMB: "元",
    Dollar: "美元",
    Alipay: "支付宝",
    WeChat: "微信",
    Cash: "现金",
    Monthly: "月结",
    Tour: "旅游",
    Hotel: "酒店",
    Flight: "机票",
    AdviceNote: "出团通知书",
    GuestEnclosure: "客人附件",
    other: "其他",
    Electronic: "电子合同",
    ClientMessage: "给客人留言",
    SupplyMessage: "给供应留言",
    WorkmateMessage: "给同事留言",
    Traveled: "已出游",
    NotTravel: "未出游",
    Change: "变更",
    Sales: "销售",
    Refund: "退款",
    PasswordVerify: "登录密码",
    EmailVerify: "邮箱验证",
    PhoneVerify: "手机验证",
    NameVerify: "实名验证",
    SafetyProblem: "安全问题",
    WEB: "网站",
    APP: "手机",
    BtripService: "商旅服务",
    HotelService: "酒店服务",
    TourService: "旅游服务",
    FlightService: "机票服务",
    ChargeService: "增值服务",
    HightDirector: "高中班主任是谁",
    Firstgame: "第一次通关的游戏",
    PhoneContact: "手机",
    TelephoneContact: "电话",
    EmailContact: "邮箱",
    QQ: "QQ",
    OnlineKnow: "网上预订须知",
    TourKnow: "国内旅游预订须知",
    Enable: "启用",
    UnEnable: "禁用",
    PriceEnable: "价格启用",
    PriceUnEnable: "价格禁用",
    Indeterminate: "价格待定",
    PrivatePolicy: "私有政策",
    PublicPolicy: "公有政策",
    Receive: "收款",
    Payment: "付款",
    Unsubmit: "未提交",
    Submited: "已提交",
    Unaudit: "未审批",
    Audited: "已审批",
    AuditRefuse: "审批拒绝",
    Untreated: "未处理",
    RefundeBad: "退团失败",
    RefundeIng: "退团处理中",
    Refunded: "退团成功",
    Country: "国家",
    Scenic: "景区",
    City: "城市",
    Province: "省",
    Area: "区域",
    Airport: "机场",
    Continent: "洲",
    District: "区",
    Invite: "自取",
    Mail: "邮寄",
    insideOutside: "国内始发",
    outsideInside: "直飞SOTO程",
    insideInsideOutside: "国内始发Add-On",
    outsideInsideInside: "国外始发Add-On",
    outsideOutside: "境外到境外",
    insideOutsideOutside: "国内始发中转",
    outsideOutsideInside: "国外始发中转",
    outsideOutsideOutside: "境外境外境外",
    outsideInsideOutside: "境外境内境外",
    globalGlobal: "全球到全球",
    globalGlobalGlobal: "全球中转全球",
    openAgencyFee: "可开无代理费",
    NoWay: "不可开",
    InsuranceService: "保险服务",
    ExpressService: "快递服务",
    InvoiceService: "发票服务",
    VisaService: "签证服务",
    TrainService: "火车服务",
    TravelNotes: "预订须知",
    ExpenseKnowledge: "费用须知",
    ShortMessage: "短信",
    Mail: "邮件",
    Wechat: "微信",
    EexamineOrderSms: "审批订单消息内容",
    EexamineApprovalSms: "审批通过消息内容",
    EexamineRefuseSms: "审批拒绝消息内容",
    EexamineAccomplishSms: "订单处理完成消息内容",
    Refunds: "退款完成",
    Transfer: "转账",
    Train: "火车票",
    BusinessSeat: "商务座",
    SpecialSeat: "特等座",
    Level1Seat: "一等座",
    Level2Seat: "二等座",
    HighGradeSleeper: "高级软卧",
    CommonSleeper: "软卧",
    HardSleeper: "硬卧",
    SoftSeat: "软座",
    HardSeat: "硬座",
    NotHaveSeat: "无座",
    Economy: "经济舱",
    Buissenes: "公务舱",
    First: "头等舱",
    DayLowestPrice: "全天最低价",
    FlightLowestPrice: "全航班最低价",
    HighSpeedRail: "高铁",
    SleepingBerth: "卧铺",
    Other: "普车及其它",
    Whole: "全部",
    Position: "职位",
    Department: "部门",
    FlatFeeCharges: "按固定收费",
    PercentageCostFee: "按百分比收费",
    Department: "本部门",
    DepartmentLower: "本部门及下级",
    TravelPurpose: "差旅目的",
    PolicyCause: "政策原因",
    FlightChange: "我要改变行程,不想飞了",
    FlightMistaken: "记错行程、日期、时间、姓名",
    FlightDelay: "航班延误或取消",
    OnBusiness: "因公",
    OnPersonal: "因私",
    PayApproval: "订单支付审批",
    ChangeApproval: "订单改签审批",
    ReturnTicketApproval: "订单退票审批",
    People: "按人收费",
    legs: "按航段收费",
    OnLineReservation: "线上预订",
    OffLineReservation: "线下预订",
    WorkingTime: "工作时间",
    NonWorkingTime: "非工作时间",
    OnlineBookingApproval: "线上预订需要审批",
    OfflineBookingApproval: "线下预订需要审批",
    ViolateRuleApproval: "违背规则需要审批",
    ChangeTripApproval: "更改行程需要审批",
    CancelTripApproval: "取消行程需要审批",
    Preflight: "起飞前",
    AfterTakeoff: "起飞后",
    RuleEndorse: "改签",
    RuleFund: "退票",
    Reserve: "预订",
    CaterService: "餐饮服务",
    TrafficService: "交通服务",
    TicketService: "门票服务",
    BaseService: "基础服务",
    Volunteer: "自愿",
    FlightChang: "航变",
    BuyAgain: "重购",
    SickAmend: "病退",
    NameError: "名字错误",
    CabinChange: "升舱换开",
    TicketInvalid: "废票",
    Other: "其他",
    WaitSubmit: "待提交",
    WaitPayment: "待付款",
    WaitConfirm: "未确认",
    Finished: "已确认",
    Canceled: "已取消",
    Rejected: "已退回",
    SystemService: "系统服务",
    WorkService: "工作服务",
    OrderService: "订单服务",
    BillService: "账单服务",
    UserService: "个人服务",
    CompanyService: "企业服务",
    TicketFare: "票面",
    BuildFare: "机建",
    FuelFare: "燃油",
    TaxFare: "税费",
    SafeFare: "保险",
    ServiceFare: "服务",
    HotelFare: "房费",
    TeamFare: "团费",
    AmendFare: "退票",
    ChangeFare: "变更",
    OtherFare: "其它",
    DirectReduction: "直减",
    ThrowDiscount: "折扣",
    Infant: "婴儿",
    Enfant: "儿童",
    Young: "成人",
    Wrinkly: "中年",
    Elderly: "老年",
    BusinessLicence: "营业执照",
    TaxRegistration: "税务登记证",
    Other: "其他",
    WaitSubmit: "待提交",
    WaitDispose: "待处理",
    Cannot: "暂不能",
    Finished: "已完成",
    Rejected: "已拒绝",
    Bill: "审批",
    Balance: "余额",
    Credit: "信用",
    Integral: "积分",
    FixedCredit: "固定授信",
    InterimCredit: "临时授信",
    WaitOutDay: "待出帐",
    WaitAudited: "待审核",
    WaitConfirm: "待确认",
    WaitReceive: "待收款",
    Finished: "已关账",
    Rejected: "已退回",
    Change: "改签",
    Bill: "账务",
    Company: "公司",
    Product: "产品",
    Sales: "销售",
    Amend: "退费",
    People: "个人",
    Customer: "客服",
    HotelChange: "行程变更",
    Station: "车站",
    CompanyID: "公司",
    People: "个人",
    SpecialTicket: "专票",
    GeneralTicket: "普票",
    Electronic: "电子发票",
    Paper: "纸质发票",
    HotelDelay: "行程取消",
    Economy5: "5折经济舱",
    Economy6: "6折经济舱",
    Economy7: "7折经济舱",
    Economy8: "8折经济舱",
    Economy9: "9折经济舱",
    MessageNotify: "短信通知",
    MailNotify: "邮件通知",
    WechatNotify: "微信通知",
    AppNotify: "App通知",
    WaitOutDay: "待出帐",
    OverdueNo: "未逾期",
    OverdueYes: "已逾期",
    Percentage: "百分比",
    FixMoney: "固定金额",
    RemovePrice: "剔除价格",
    Creater: "创建者",
    Member: "参与者",
    Watcher: "关注者",
    Text: "文本",
    Html: "HTML",
    Link: "链接",
    Plugin: "插件",
    CompanyInternal: "公司内部",
    CurrentDomainName: "当前域名",
    AllDomainName: "所有域名",
    Email: "电子邮件",
    OrdinaryAddress: "普通地址",
    B2C: "B2C",
    B2G: "B2G",
    Demand: "需求",
    WaitBooking: "待预订",
    WaitApprove: "待审批",
    WaitConfirm: "待确认",
    WaitPayment: "待支付",
    WaitDispose: "待处理",
    Finished: "已完成",
    Canceled: "已取消",
    Rejected: "已退回",
    Discrete: "已拆分",
    Cannot: "暂不能",
    EmailAuth: "邮箱账号",
    MobileAuth: "手机账号",
    AccountAuth: "用户账号",
    WeixinAuth: "微信授权",
    DynamicAuth: "动态验证",
    BookingInfo: "预订须知",
    PolicyCause: "违背原因",
    TravelPurpose: "差旅目的",
    WaitRefund: "待退款",
  },
};



// WEBPACK FOOTER //
// ./src/lang/CN.js